import Vue from "vue";
import VueDndZone from "vue-dnd-zone";
import "vue-dnd-zone/vue-dnd-zone.css";

Vue.use(VueDndZone);
